import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { logNavigation, logDiagnostic } from './utils/diagnosticLogger';

import Retail from './pages/retail';
import Jobs from './pages/jobs';
import Accounts from './pages/accounts';
import Inbox from './pages/inbox';
import ReportsPage from './pages/reports';
import QuickBooksCallback from './pages/QuickBooksCallback';
import EULA from './pages/EULA';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Wheels from './pages/wheels';
import Inventory from './pages/inventory';

// Component to track route changes
const RouteTracker = () => {
  const location = useLocation();
  const prevLocation = React.useRef(location);

  useEffect(() => {
    if (prevLocation.current.pathname !== location.pathname) {
      logNavigation(
        prevLocation.current.pathname,
        location.pathname,
        'route-change'
      );
      
      // Check if this was a full page reload (React Router shouldn't cause this)
      const navigationEntry = performance.getEntriesByType('navigation')[0];
      if (navigationEntry && navigationEntry.type === 'reload') {
        logDiagnostic('navigation', 'full-page-reload-during-route-change', {
          from: prevLocation.current.pathname,
          to: location.pathname,
          navigationType: navigationEntry.type
        });
      }
      
      prevLocation.current = location;
    }
  }, [location]);

  return null;
};

const AppRouter = () => {
  return (
    <Router>
      <RouteTracker />
      <Routes>
        <Route path="/" element={<Retail />} />
        <Route path='/jobs' element={<Jobs />} />
        <Route path='/reports' element={<ReportsPage />} />
        <Route path='/accounts' element={<Accounts />} />
        <Route path='/inbox' element={<Inbox />} />
        <Route path='/quickbooks/callback' element={<QuickBooksCallback />} />
        <Route path='/wheels' element={<Wheels />} />
        <Route path='/inventory/powder' element={<Inventory />} />
        <Route path='/eula' element={<EULA />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
